import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import TablePagination from '@mui/material/TablePagination';
import { Badge } from 'react-bootstrap';
import { Button, Card, TableContainer, Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

const CompanyNonOrgMemberTable = ({
  rowData,
  colName,
  dataFrame,
  sortBy = null,
  delFunc = null,
  editModalOpen = null,
  selectedMemberNos,
  setSelectedMemberNos,
  ...props
}) => {
  const [page, setPage] =useState(0);
  const [rowsPerPage, setRowsPerPage] =useState(5);
  const [orderBy, setOrderBy] =useState('');
  const [order, setOrder] =useState('');
  const dispatch = useDispatch();

  const handleClick = (event, id) => {
    const selectedIndex = selectedMemberNos.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedMemberNos, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedMemberNos.slice(1));
    } else if (selectedIndex === selectedMemberNos.length - 1) {
      newSelected = newSelected.concat(selectedMemberNos.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedMemberNos.slice(0, selectedIndex),
        selectedMemberNos.slice(selectedIndex + 1),
      );
    }
    setSelectedMemberNos(newSelected);
  };

  const handleSortRequest = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  };

  // Comparator function generator based on the order and orderBy properties
  const getComparator = (order, orderBy) => {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  };

  // Function to stabilize and sort the rows based on the specified comparator
  const sortedRowInformation = (rowArray, comparator) => {
    // Sort the row array using the provided comparator
    const sortedRows = [...rowArray].sort(comparator);
    return sortedRows;
  };
  const handleButtonClick = (index, direction) => {
    handleSortRequest(sortBy[index]);
    const buttons = document.querySelectorAll('.arrow-button');
    buttons.forEach((button, i) => {
      button.style.color = '#E2E2E2'; // Set color to default
    });
    document.getElementById(`arrow-button-${index}-${direction}`).style.color = 'black';
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getValueFromNestedObject = (obj, keyPath) => {
    return keyPath.split('.').reduce((acc, key) => acc && acc[key], obj);
  };

  const isItemSelected = (val) => {
    return selectedMemberNos.indexOf(val) !== -1
  }

  return (
    <React.Fragment>
      <TableContainer sx={{ border: 1, borderColor: '#E2E2E2', maxHeight: '55vh' }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead
            sx={{
              '& .MuiTableCell-head': {
                backgroundColor: '#E2E2E2',
                padding: '10px 16px',
              },
            }}
          >
            <TableRow>
              {colName.map((val, index) => (
                <TableCell key={index} sx={{ fontWeight: 'bold' }}>
                  {val}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rowData.length > 0 ? (
              (sortBy !== null ? sortedRowInformation(rowData, getComparator(order, orderBy)) : rowData)
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((val, index) => (
                  <TableRow key={index}   
                  hover
                  onClick={(event) => handleClick(event, val.uuid)}
                  selected={isItemSelected(val.uuid)}
                  style={{cursor: 'pointer'}}
                  >
                    {dataFrame.map((frameVal, frameIndex) =>
                      frameVal.hasOwnProperty('isClick') ? (
                        // 目前暫無使用isClick 
                        <TableCell key={frameIndex} style={{ width: '23%', padding: '10px 8px'}}>
                          <>
                            <Button
                              style={{
                                color: '#323232',
                                fontSize: '13px',
                                fontWeight: 'bold',
                                padding: '0px'
                              }}
                              variant="text"
                              onClick={() => {
                                editModalOpen(val);
                              }}
                            >
                              設為主管
                            </Button>
                            <Button
                              style={{
                                color: '#323232',
                                fontSize: '13px',
                                fontWeight: 'bold',
                                padding: '0px'
                              }}
                              variant="text"
                              onClick={() => {
                                delFunc(val);
                              }}
                            >
                              刪除
                            </Button>
                          </>
                        </TableCell>
                      ) : (
                        <TableCell key={frameIndex} style={{ width: frameIndex === 0 ? '17%' : '30%', padding: '10px 8px' }}>
                          {getValueFromNestedObject(val, frameVal.keyName)}
                        </TableCell>
                      )
                    )}
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell>查無資料</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        className="mt-3"
        component="div"
        rowsPerPageOptions={[5, 10, 20]}
        count={rowData.length}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        labelRowsPerPage="每頁顯示 :"
        onRowsPerPageChange={handleChangeRowsPerPage}
        SelectProps={{
          renderValue: (value) => (value === rowData.length ? 'All' : value),
          MenuProps: {
            disablePortal: true,
            PaperProps: {
              sx: {
                zIndex: 13100,
              },
            },
          },
        }}
        sx={{
          '.MuiTablePagination-displayedRows, .MuiTablePagination-selectLabel': {
            marginTop: '1em',
            marginBottom: '1em',
          },
        }}
      />
    </React.Fragment>
  );
};
export default CompanyNonOrgMemberTable;

CompanyNonOrgMemberTable.propTypes = {
  // table的資料
  rowData: PropTypes.array.isRequired,
  // table欄位顯示名稱
  colName: PropTypes.array.isRequired,
  // 如何取得table的資料
  dataFrame: PropTypes.arrayOf(
    PropTypes.shape({
      keyName: PropTypes.string.isRequired,
    })
  ).isRequired,
};

CompanyNonOrgMemberTable.defaultProps = {};
